module.exports = __webpack_public_path__ + "media/images/flags/tc-f4f865830e706c26ef447d41af35610d.svg";